import { UTIL_SIDEBAR_IGNORE, UtilState, UtilActionTypes, UTIL_HEADER_IGNORE, UTIL_AUTH_IGNORE, UTIL_SISTEMAID, UTIL_START_STATE, UTIL_AUTH_IGNORE_REMOVE, UTIL_SIDEBARLIST_STATE, UTIL_USERDATA_STATE, UTIL_REDUXVIEW_STATE, UTIL_DEVSIMULATE_STATE, UTIL_ROUTE, UTIL_ROUTE_STATE } from "domain/types/util/util"
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const INITIAL_STATE: UtilState = {
    SistemaID: undefined,
    SideBarIgnore: [],
    HeaderIgnore: [],
    AuthIgnore: [],
    StartState: false,
    SideBarList: [],
    UserData: undefined,
    ReduxView: { state: false, x: 0, y: 0},
    DevSimulate: false,
    ConditionalRoute: []
}

const utilPersistConfig = {
    key: "util",
    storage,
    whitelist: ["SideBarIgnore", "HeaderIgnore", "AuthIgnore", "StartState", "SideBarList", "UserData", "ReduxView", "DevSimulate", "ConditionalRoute"],
};

export const UtilReducer = persistReducer(
    utilPersistConfig,
    UtilReducerBase
);

export function UtilReducerBase(state = INITIAL_STATE, action: UtilActionTypes): UtilState {
    switch (action.type) {
        case UTIL_SISTEMAID:
            return { ...state, SistemaID: action.payload }

        case UTIL_SIDEBAR_IGNORE:

            if (state.SideBarIgnore.includes(action.payload)) {
                return state
            }

            return { ...state, SideBarIgnore: [...state.SideBarIgnore, action.payload] }

        case UTIL_HEADER_IGNORE:

            if (state.HeaderIgnore.includes(action.payload)) {
                return state
            }

            return { ...state, HeaderIgnore: [...state.HeaderIgnore, action.payload] }

        case UTIL_AUTH_IGNORE:

            if (state.AuthIgnore.includes(action.payload)) {
                return state
            }

            return { ...state, AuthIgnore: [...state.AuthIgnore, action.payload] }

        case UTIL_AUTH_IGNORE_REMOVE:
            return {
                ...state, AuthIgnore: state.AuthIgnore.filter((item) => item !== action.payload),
            };


        case UTIL_START_STATE:
            return { ...state, StartState: action.payload }

            
        case UTIL_SIDEBARLIST_STATE:
            return { ...state, SideBarList: action.payload }


        case UTIL_USERDATA_STATE:
            return { ...state, UserData: action.payload }
    

        case UTIL_REDUXVIEW_STATE:
            return { ...state, ReduxView: action.payload }
        
        case UTIL_DEVSIMULATE_STATE:
            return { ...state, DevSimulate: action.payload }

        case UTIL_ROUTE:

            if (state.ConditionalRoute.includes(action.payload)) {
                return state
            }

            return { ...state, ConditionalRoute: [...state.ConditionalRoute, action.payload] }

        case UTIL_ROUTE_STATE:
            return {
                ...state,
                ConditionalRoute: state.ConditionalRoute.map(route => 
                    route.Path === action.payload.Path 
                        ? { ...route, Status: action.payload.Status }
                        : route
                )
            };

        default:
            return state
    }
}